import { render, staticRenderFns } from "./tramite-novedad-table.vue?vue&type=template&id=6587f9fa&"
import script from "./tramite-novedad-table.vue?vue&type=script&lang=ts&"
export * from "./tramite-novedad-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports